import { ROUTES } from 'constant';
import Link from 'next/link';

import { Box, Stack, Text, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

type SavingsBlockProps = {
  title: string;
  amount: string | number;
  isGiftCardBlock?: boolean;
};

const SavingsBlock = ({
  title,
  amount,
  isGiftCardBlock = false
}: SavingsBlockProps) => {
  const {
    colors: {
      palette: {
        components: { savingBlock }
      }
    }
  } = useTheme();
  const giftCardText = isGiftCardBlock && typeof amount === 'string';
  const isRedirect = amount === 'Buy Gift Card';

  return (
    <Stack
      align='center'
      width='100%'
      height='80px'
      backgroundColor={savingBlock.bg}
      borderTopRadius={6}
      borderBottomRadius={0}
      gap={0}
      overflow='hidden'
      marginBottom='2px'
    >
      <Box bg={savingBlock.headerBg} w='100%' py='5px'>
        <Text
          fontSize={{ base: 11, lg: giftCardText ? 9 : 11 }}
          textTransform='uppercase'
          color={savingBlock.headerTextColor}
          textAlign='center'
        >
          {title}
        </Text>
      </Box>

      <Stack
        w='100%'
        height='100%'
        alignItems='center'
        justifyContent='center'
        gap={0}
      >
        <Link
          href={ROUTES.giftCardsShop}
          style={{
            fontSize: 22,
            lineHeight: '120%',
            pointerEvents: isRedirect ? 'auto' : 'none',
            fontWeight: 600,
            textDecoration: 'none',
            color: savingBlock.amountColor
          }}
        >
          {giftCardText ? amount : formatCurrency(String(amount))}
        </Link>
      </Stack>
    </Stack>
  );
};

export default SavingsBlock;
